/** Russian extra dashboard strings (extra-en + extra-en-mgmt). */
export const extraRu = {
  common: {
    close: 'Закрыть',
    show: 'Показать',
    hide: 'Скрыть',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    keep: 'Оставить',
    yes: 'Да',
    back: 'Назад',
    dismiss: 'Закрыть',
    edit: 'Изменить',
    undo: 'Отменить',
    prev: '← Назад',
    next: 'Далее →',
    pageOf: '{{page}} / {{count}}',
    showing: 'Показано {{from}}–{{to}} из {{total}}',
    exportCsv: 'Экспорт CSV',
    importing: 'Импорт…',
    saving: 'Сохранение…',
    creating: 'Создание…',
    on: 'Включено',
    off: 'Выключено',
    active: 'Активен',
    inactive: 'Неактивен',
    hidden: 'Скрыт',
    never: 'Никогда',
    all: 'Все',
    unknown: 'Неизвестно',
    noMatches: 'Нет совпадений',
    include: 'Включить',
    exclude: 'Исключить',
    selectAll: 'Выбрать все',
    clear: 'Очистить',
    filterMode: 'Режим фильтра',
    actions: 'Действия',
    confirmDelete: 'Подтвердить удаление',
    newPassword: 'Новый пароль',
    countryCode: 'Код страны',
    emptyDash: '—',
    dateRange: {
      ariaLabel: 'Период',
      from: 'С',
      to: 'По',
      today: 'Сегодня',
      days7: '7 дней',
      days30: '30 дней',
      days90: '90 дней',
      thisMonth: 'Этот месяц',
      lastMonth: 'Прошлый месяц',
      thisYear: 'Этот год',
      allTime: 'Всё время',
      custom: 'Свой период',
    },
  },
  nav: {
    groups: {
      insights: 'Аналитика',
      books: 'Бухгалтерия',
      operations: 'Операции',
      management: 'Управление',
      crm: 'CRM',
      system: 'Система',
      admin: 'Администрирование',
    },
    language: 'Язык',
    openMenu: 'Открыть меню',
    themeLight: 'Включить светлую тему',
    themeDark: 'Включить тёмную тему',
    books: 'Выгрузка',
    role: {
      owner: 'владелец',
      admin: 'администратор',
      manager: 'менеджер',
      accountant: 'бухгалтер',
      super_admin: 'суперадминистратор',
      anon: 'аноним',
    },
  },
  auth: {
    createAccount: 'Создать аккаунт',
    accountCreated: 'Аккаунт создан. Теперь можно войти.',
    needAccount: 'Нет аккаунта? Зарегистрируйтесь',
    haveAccount: 'Уже есть аккаунт? Войдите',
    notConfiguredBody: 'Создайте проект Supabase, скопируйте apps/dashboard/.env.example в apps/dashboard/.env и укажите VITE_SUPABASE_URL и VITE_SUPABASE_ANON_KEY. Перезапустите сервер разработки.',
    noRoleBodyExtended: 'У этого аккаунта ещё нет роли. Попросите суперадминистратора выдать доступ или выполните SQL начальной настройки суперадминистратора.',
  },
  wasteReasons: {
    expired: 'Истёк срок',
    spoiled: 'Испорчено',
    quality_issue: 'Проблема качества',
    non_saleable: 'Не для продажи',
    prep_waste: 'Отходы приготовления',
    burnt: 'Пригорело',
    spillage: 'Пролито',
    damaged: 'Повреждено',
    staff_meal: 'Питание сотрудников',
    other: 'Другое',
  },
  landing: {
    signIn: 'Войти',
    lead: 'POS для армянских кафе.',
    downloads: {
      "macos-arm64": 'Mac (Apple silicon)',
      "macos-x64": 'Mac (Intel)',
      "windows-x64": 'Windows',
    },
  },
  dashboard: {
    title: 'Панель',
    loading: 'Загрузка панели…',
    loadFailed: 'Не удалось загрузить',
    couldntLoad: 'Не удалось загрузить панель',
    revenueToday: 'Выручка сегодня',
    ordersToday: 'Заказы сегодня',
    averageOrder: 'Средний чек',
    coversToday: 'Гости сегодня',
    givenAwayToday: 'Бесплатно сегодня',
    tipsToday: 'Чаевые по карте',
    staffToday: 'Сотрудники сегодня',
    staffWage: 'Зарплата',
    staffTodayEmpty: 'Сегодня в табеле никого нет.',
    bookingsToday: 'Бронирования сегодня',
    bookingsInHouse: 'Проживают',
    bookingsArriving: 'Заезд',
    bookingsLeaving: 'Выезд',
    bookingsPending: 'Ожидает',
    categoryShare: 'Сегодня по категориям',
    noCategorySales: 'Сегодня продаж нет.',
    uncategorised: 'Без категории',
    vsYesterday: 'к вчерашнему дню',
    revenueChart: 'Выручка',
    last30: 'Последние 30 дней',
    paymentSplit: 'Разбивка оплат',
    noPayments30: 'За последние 30 дней оплат нет.',
    cash: 'Наличные',
    card: 'Карта',
    ordersByHour: 'Заказы по часам',
    last7: 'Последние 7 дней',
    orders: 'Заказы',
    topProducts: 'Топ товаров',
    topProductsCaption: 'Последние 30 дней по выручке',
    noSales30: 'За последние 30 дней продаж нет.',
    stockIn: 'Приход',
    lowStock: 'Низкий остаток',
    lowStockCaption: '{{count}} ингредиент(ов) на пороге или ниже',
    lowStockNegative: ' · {{count}} с отрицательным остатком',
    prep: 'Заготовки',
    threshold: 'Порог {{value}}',
  },
  sales: {
    title: 'Продажи',
    subtitleRange: '{{from}} – {{to}} · {{comparison}}',
    tabRevenue: 'Выручка',
    tabOrders: 'Заказы',
    loadFailed: 'Не удалось загрузить',
    couldntLoad: 'Не удалось загрузить продажи',
    vsYesterday: 'к вчерашнему дню',
    vsPrevious7: 'к предыдущим 7 дням',
    vsPrevious30: 'к предыдущим 30 дням',
    vsPrevious90: 'к предыдущим 90 дням',
    vsMonthBefore: 'к предыдущему месяцу',
    vsSameSpanLastYear: 'к тому же периоду прошлого года',
    vsPreviousPeriod: 'к предыдущему периоду',
    revenue: 'Выручка',
    paidOrders: 'Оплаченные заказы',
    averageOrder: 'Средний чек',
    covers: 'Гости',
    revenuePerCover: 'Выручка на гостя',
    cardTips: 'Чаевые по карте',
    tipRateOnCard: 'Доля чаевых в карточных заказах',
    averageTipWhenTipped: 'Средние чаевые, когда оставлены',
    note: 'Выручка и средний чек — только товары; чаевые по карте учитываются отдельно. В разбивке оплат чаевые входят в сумму по карте.',
    revenueTrend: 'Динамика выручки',
    byHour: 'По часам',
    byDay: 'По дням',
    paymentSplit: 'Разбивка оплат',
    noPaymentData: 'Нет данных об оплатах.',
    cash: 'Наличные',
    card: 'Карта',
    forceCloseByReason: 'Принудительное закрытие по причине',
    noForceClosed: 'В этом периоде нет принудительно закрытых заказов.',
    reasonMistake: 'ошибка',
    reasonSystemError: 'системная ошибка',
    reasonFree: 'бесплатно',
    reasonOther: 'другое',
    allOrders: 'Все заказы',
    paid: 'Оплачен',
    refunded: 'Возврат',
    void: 'Аннулирован',
    forceClosed: 'Принудительно закрыт',
    refundRate: 'Доля возвратов',
    forceCloseRate: 'Доля принудительных закрытий',
    orderQuality: 'Качество заказов',
    avgItems: 'Среднее число позиций в заказе',
    modifierAttach: 'Доля заказов с модификаторами',
    paidShare: 'Доля оплаченных заказов',
    totalCovers: 'Всего гостей',
  },
  orders: {
    title: 'Заказы',
    subtitleFiltered: '{{filtered}} из {{total}}',
    subtitleTotal: '{{amount}} всего',
    subtitlePaid: '({{amount}} оплачено)',
    live: '● Онлайн',
    liveUpdates: 'Живые обновления',
    closeReason: 'Причина закрытия',
    compType: 'Тип бесплатного',
    compRecipient: 'Получатель комплимента',
    reprint: 'Повторить печать',
    reprintTitle: 'Повторить печать чека',
    searchPlaceholder: 'Поиск по номеру, ID, TIN…',
    allStatuses: 'Все статусы',
    statusOpen: 'открыт',
    statusPaid: 'оплачен',
    statusVoid: 'аннулирован',
    statusRefunded: 'возврат',
    paymentUnpaid: 'не оплачен',
    paymentPartial: 'частично',
    allCompTypes: 'Все типы комплиментов',
    allRecipients: 'Все получатели',
    menuItems: 'Позиции меню',
    searchMenu: 'Поиск по меню…',
    inactiveSuffix: ' (неактивен)',
    paymentType: 'Тип оплаты',
    all: 'Все',
    cash: 'Наличные',
    card: 'Карта',
    shiftId: 'ID смены',
    clearShift: 'Сбросить фильтр смены',
    forcedOnly: 'Только принудительно закрытые',
    missingPayments: '{{count}} оплаченных заказов без строки оплаты',
    colNumber: '#',
    colTime: 'Время',
    colStatus: 'Статус',
    colPayment: 'Оплата',
    colTotal: 'Итого',
    colCashierShift: 'Кассир / смена',
    colTin: 'TIN',
    colComp: 'Комплимент',
    colForced: 'Принудительно',
    missing: 'нет записи',
    missingTitle: 'Для этого заказа нет строки оплаты',
    pay: 'оплата',
    payMismatch: 'Оплата {{paid}} ≠ ожидалось {{expected}} (к оплате {{due}})',
    payMismatchTip: 'Оплата {{paid}} ≠ ожидалось {{expected}} (к оплате {{due}} + чаевые {{tip}})',
    fiscal: 'фискальный',
    fiscalMismatch: 'Списано {{charged}}, а фискальный чек показывает {{fiscal}}',
    inclLoyalty: 'в т.ч. −{{amount}} лояльность',
    plusTip: '+ {{amount}} чаевые',
    goToShift: 'Перейти к этой смене',
    empty: 'Нет заказов, подходящих под фильтры.',
    detailTitle: 'Заказ #{{number}}',
    cashier: 'Кассир',
    closedBy: 'Закрыл',
    shift: 'Смена',
    openShift: 'Открытая смена',
    forceClosed: 'Принудительно закрыт',
    noReason: 'без причины',
    unknownRecipient: 'Неизвестно',
    loyalty: 'Лояльность',
    member: 'Участник',
    removedMember: 'Удалённый участник',
    discount: 'Скидка',
    pointsRedeemed: 'Списанные баллы',
    totals: 'Итоги',
    itemsSubtotal: 'Сумма позиций',
    loyaltyDiscount: 'Скидка лояльности',
    amountDue: 'К оплате',
    cardTip: 'Чаевые по карте',
    charged: 'Списано',
    items: 'Позиции',
    colName: 'Название',
    colQty: 'Количество',
    colUnitPrice: 'Цена за ед.',
    colDiscount: 'Скидка',
    colLineTotal: 'Сумма строки',
    noItems: 'В этом заказе нет позиций.',
    payments: 'Оплаты',
    colMethod: 'Способ',
    colAmount: 'Сумма',
    noPayments: 'Оплаты не записаны.',
    fiscalTitle: 'Фискальный чек',
    fiscalMatches: 'Фискальная сумма {{fiscal}} совпадает со списанной {{charged}}.',
    fiscalMismatchTitle: 'Фискальное расхождение',
    fiscalMismatchBody: 'списано {{charged}}, а фискальный чек HDM показывает {{fiscal}} (разница {{gap}} в чеке). Напечатанная фискальная сумма может не совпадать с полученной.',
    fiscalNumber: 'Фискальный #',
    fiscalTotal: 'Фискальная сумма',
    change: 'Сдача',
    csvNumber: 'number',
    csvCreated: 'created_at',
    csvStatus: 'status',
    csvPayment: 'payment_status',
    csvTotal: 'total',
    csvForced: 'forced_close',
    csvCloseReason: 'close_reason',
    csvCompType: 'comp_type',
    csvCompRecipient: 'comp_recipient',
    csvTin: 'partner_tin',
    csvShift: 'shift_id',
    csvId: 'id',
  },
  shifts: {
    title: 'Смены',
    subtitle: '{{count}} смен',
    paymentMethod: 'Способ оплаты',
    all: 'Все',
    cash: 'Наличные',
    card: 'Карта',
    overallTotal: 'Общая сумма',
    cashTotal: 'Сумма наличными',
    cardTotal: 'Сумма по карте',
    empty: 'В этом периоде смен нет.',
    colOpened: 'Открыта',
    colClosed: 'Закрыта',
    colCashier: 'Кассир',
    colOrders: 'Заказы',
    colVoid: 'Аннулировано',
    colForced: 'Принудительно',
    colTotal: 'Итого',
    colCash: 'Наличные',
    colCard: 'Карта',
    colStatus: 'Статус',
    showBreakdown: 'Показать разбивку',
    statusOpen: 'открыта',
    statusClosed: 'закрыта',
    shiftId: 'ID смены',
    openingFloat: 'Размен при открытии',
    paidOrders: 'Оплаченные заказы',
    paidOf: '{{paid}} из {{total}}',
    viewOrders: 'Смотреть заказы →',
    reassign: 'Сменить кассира',
    selectCashier: '— выбрать кассира —',
    cashierHdm: ' (HDM #{{no}})',
    cashierNoHdm: ' · нет номера HDM',
    reassignNoHdm: 'У выбранного кассира нет номера HDM — сначала укажите его в разделе «Кассиры».',
    paymentBreakdown: 'Разбивка оплат',
    noPayments: 'Оплаты не записаны.',
    colMethod: 'Способ',
    grandTotal: 'Итого',
    unrecorded: '{{amount}} не записано — у части заказов нет строк оплаты. Сумма по заказам: {{orderTotal}}',
    expenses: 'Расходы / выдача наличных',
    noExpenses: 'Расходы не записаны.',
    colCategory: 'Категория',
    colDescription: 'Описание',
    colAddedBy: 'Добавил',
    colAmount: 'Сумма',
    total: 'Итого',
    addExpense: '+ Добавить расход',
    amountAmd: 'Сумма (AMD)',
    descriptionPlaceholder: 'например, ночное такси для сотрудников',
    errorPositive: 'Введите положительную сумму.',
    errorDescription: 'Описание обязательно.',
    catTaxi: 'такси',
    catSupplies: 'материалы',
    catMeals: 'питание',
    catDelivery: 'доставка',
    catOther: 'другое',
    expectedCash: 'Ожидаемые наличные в ящике',
    expectedFormula: '{{cashSales}} продаж наличными − {{expenses}} расходов = {{result}}',
  },
  cashDrops: {
    title: 'Инкассация',
    subtitle: 'Наличные на конец дня к изъятию · только владелец/администратор',
    refreshExpected: 'Обновить ожидаемые суммы',
    syncing: 'Синхронизация…',
    markCollected: 'Отметить как изъято',
    waiting: '{{count}} инкассаций ожидают',
    expectedTotal: 'Ожидаемая сумма: {{amount}}',
    syncFailed: 'Синхронизация не удалась',
    invalidCounted: 'Введите корректную пересчитанную сумму.',
    colDay: 'День',
    colExpected: 'Ожидалось',
    colCounted: 'Пересчитано',
    colStatus: 'Статус',
    colCollected: 'Изъято',
    colCollectedBy: 'Изъял',
    showExpenses: 'Показать расходы',
    hideExpenses: 'Скрыть расходы',
    expenseSummary: '{{count}} расходов · −{{amount}}',
    pending: 'Ожидает',
    collected: 'Изъято',
    empty: 'Инкассаций ещё нет. Нажмите «Обновить ожидаемые суммы», чтобы создать их из продаж наличными.',
    cashSales: 'Продажи наличными',
    expenses: 'Расходы',
    expected: 'Ожидалось',
    colTime: 'Время',
    colCategory: 'Категория',
    colDescription: 'Описание',
    colBy: 'Кто',
    colAmount: 'Сумма',
    catTaxi: 'Такси',
    catSupplies: 'Материалы',
    catMeals: 'Питание',
    catDelivery: 'Доставка',
    catOther: 'Другое',
    collectTitle: 'Изъять наличные — {{day}}',
    expectedLabel: 'Ожидалось: {{amount}}',
    countedLabel: 'Пересчитанная сумма (֏)',
    noteLabel: 'Заметка (необязательно)',
    confirm: 'Подтвердить изъятие',
  },
  inventoryInsights: {
    title: 'Склад',
    subtitle: 'Потери, состояние остатков, движения и поток',
    tabLoss: 'Потери и расхождения',
    tabStock: 'Состояние остатков',
    tabTransactions: 'Операции',
    tabFlow: 'Поток остатков',
    loadFailed: 'Не удалось загрузить',
    notConfigured: 'Не настроено',
    couldntLoad: 'Не удалось загрузить склад',
    stockOverview: 'Обзор остатков',
    totalCount: '{{count}} всего',
    lowCount: '{{count}} низкий остаток',
    criticalCount: '{{count}} критично',
    searchIngredient: 'Поиск ингредиента…',
    colIngredient: 'Ингредиент',
    colStock: 'Остаток',
    colThreshold: 'Порог',
    colStatus: 'Статус',
    statusOk: 'Норма',
    statusLow: 'Низкий',
    statusCritical: 'Критично',
    noResults: 'Нет результатов',
    mostDepleted: 'Больше всего израсходовано (за всё время)',
    depleted: 'Израсходовано',
    txLog: 'Журнал операций ({{count}} записей)',
    typeSale: 'Продажа',
    typeRestock: 'Приход',
    typeAdjustment: 'Корректировка',
    typeWaste: 'Списание',
    typeStockCount: 'Инвентаризация',
    typeCountRevert: 'Отмена инвентаризации',
    typeWasteRevert: 'Отмена списания',
    typeInvoice: 'Накладная',
    typeInvoiceRevert: 'Отмена накладной',
    typePrep: 'Заготовка',
    typeForceClose: 'Принудительное закрытие',
    colDate: 'Дата',
    colType: 'Тип',
    colDelta: 'Дельта',
    colNote: 'Заметка',
    noTransactions: 'Операций нет',
    colStockIn: 'Приход',
    colStockOut: 'Расход',
    colNet: 'Нетто',
    selectRange: 'Выберите период выше.',
    noTxPeriod: 'В этом периоде операций нет.',
    allIngredients: 'Все ингредиенты',
    categoryAll: 'Все',
    categoryWaste: 'Списание',
    categoryUnknown: 'Неизвестно',
    lossRate: 'Доля потерь',
    netLoss: 'Нетто {{pct}}% · −{{amount}}',
    formula: '(Списание + Неизвестно ↓) ÷ стоимость прихода',
    benchmark: 'Цель: менее 2–5% закупок · Приход {{amount}}',
    waste: 'Списание',
    unknownDown: 'Неизвестно ↓',
    unknownUp: 'Неизвестно ↑',
    ofStockIn: '{{pct}}% прихода',
    recovered: 'Восстановлено инвентаризацией',
    periodFlow: 'Поток за период (стоимость)',
    stockIn: 'Приход',
    dailyTrend: 'Динамика потерь по дням',
    trendLegend: 'Столбцы: сумма потерь · Линия: % прихода',
    noLoss: 'В этом периоде потерь нет.',
    topLoss: 'Наибольшие потери',
    byValueAll: 'По стоимости · списание + неизвестно ↓',
    byValueWaste: 'По стоимости · только списание',
    byValueUnknown: 'По стоимости · только неизвестно ↓',
    noLossItems: 'В этом периоде позиций с потерями нет.',
    noLoggedWaste: 'В этом периоде списаний нет.',
    noUnknown: 'В этом периоде неизвестных расхождений нет.',
    wasteByReason: 'Списания по причинам',
    wasteOnly: 'Только учтённые списания',
    wasteFilterOff: 'Фильтр списаний не активен',
    selectWasteOrAll: 'Выберите «Списание» или «Все», чтобы увидеть причины.',
    vsDown: 'Приход и отрицательное расхождение',
    vsUp: 'Приход и положительное расхождение',
    modeQty: 'Количество',
    modeValue: 'Стоимость',
    mixedUnits: 'Разные единицы — отфильтруйте по ингредиенту, чтобы подписать количества.',
    noDataPeriod: 'В этом периоде данных нет.',
    varianceDown: 'Отрицательное расхождение',
    varianceUp: 'Положительное расхождение',
    lossEvents: 'События потерь',
    wasteEvents: 'События списания',
    unknownEvents: 'Неизвестные расхождения',
    colWhen: 'Когда',
    colCategory: 'Категория',
    colValue: 'Стоимость',
    colDetails: 'Подробности',
    catWaste: 'Списание',
    catUnknown: 'Неизвестно',
    catReverted: 'Отменено',
    noLossData: 'В этом периоде данных о потерях нет.',
    netLossLabel: 'Чистые потери',
    varianceRatio: '{{label}} = {{pct}}% прихода',
    stockInPct: 'Приход {{pct}}%',
    compareAria: 'Приход {{stockPct}}%, {{label}} {{varPct}}%',
    tooltipWaste: 'Списание: −{{amount}}',
    tooltipUnknownDown: 'Неизвестно ↓: −{{amount}}',
    tooltipTotalLoss: 'Всего потерь: −{{amount}}',
    tooltipLossRate: 'Доля потерь: {{pct}}% прихода',
    wasteAmount: 'Списание −{{amount}}',
    unknownAmount: 'Неизвестно −{{amount}}',
    wasSystemCounted: 'Было в системе {{system}} → пересчитано {{counted}} {{unit}}',
    systemCounted: 'В системе {{system}} → пересчитано {{counted}} {{unit}}',
  },
  menuInsights: {
    title: 'Аналитика меню',
    subtitle: 'Что продаётся, что зарабатывает и что исправить',
    tabProducts: 'Товары',
    tabCategories: 'Категории',
    loadFailed: 'Не удалось загрузить',
    notConfigured: 'Не настроено',
    couldntLoad: 'Не удалось загрузить аналитику меню',
    vatTaxable: 'Облагается НДС',
    vatExempt: 'Освобождено от НДС',
    turnoverTax: 'Налог с оборота',
    uncategorised: 'Без категории',
    unknownDept: 'Неизвестно',
    deptPrefix: 'Отдел {{id}}',
    dailyByItem: 'Продажи по дням и позициям',
    dailyByCategory: 'Продажи по дням и категориям',
    noSales: 'Нет данных о продажах за этот период.',
    selectItem: 'Выберите хотя бы одну позицию, чтобы показать график.',
    include: 'Включить',
    includeCount: '{{selected}} / {{total}} включено',
    chartTotal: 'Итого: {{amount}} · {{count}} рядов включено',
    filterAll: 'Все',
    filterNone: 'Ничего',
    noMatches: 'Совпадений нет',
    modeRevenue: 'Выручка',
    modeQuantity: 'Количество',
    pctOfDay: '{{pct}}% дня',
    topProducts: 'Топ товаров',
    byRevenue: 'По выручке',
    byQty: 'По количеству',
    bottomSellers: 'Слабые продажи (последние 5)',
    revenueByCategory: 'Выручка по категориям',
    categoryShare: 'Доля категории',
    revenueByDept: 'Выручка по отделу / типу налога',
    tooltipRevenue: 'Выручка',
  },
  staffInsights: {
    title: 'Аналитика персонала',
    subtitle: 'Часы, зарплата и доля каждого в чаевых.',
    loadFailed: 'Не удалось загрузить',
    notConfigured: 'Не настроено',
    couldntLoad: 'Не удалось загрузить аналитику персонала',
    empty: 'Сотрудников ещё нет. Добавьте людей и их время на странице «Сотрудники».',
    noHours: 'В этом диапазоне нет часов, поэтому чаевые не делятся.',
    tipExplain: 'Чаевые с оплаченных заказов делятся по часам. Зарплата считается по ставке того дня.',
    chartTitle: 'Зарплата',
    chartTips: 'Чаевые',
    hours: 'Часы',
    wages: 'Зарплата',
    tipPool: 'Чаевые',
    totalPay: 'Итого',
    colName: 'Имя',
    colHours: 'Часы',
    colShare: 'Доля часов',
    colWage: 'Зарплата',
    colTip: 'Чаевые',
    colTotal: 'Итого',
  },
  businessHealth: {
    title: 'Здоровье бизнеса',
    subtitle: 'Прибыльность, безубыточность и эффективность меню',
    monthAria: 'Месяц',
    loadFailed: 'Не удалось загрузить',
    couldntLoad: 'Не удалось загрузить здоровье бизнеса',
    profitable: 'В этом месяце прибыльно',
    losing: 'В этом месяце убыточно',
    biggestCost: 'Крупнейшая статья: {{label}} ({{amount}}, {{pct}} выручки)',
    revenue: 'Выручка',
    grossMargin: 'Валовая маржа',
    netMargin: 'Чистая маржа',
    covers: 'Гости',
    paidOrders: 'Оплаченные заказы',
    plTitle: 'Разбивка прибылей и убытков',
    helpRevenue: 'Выручка — сумма оплаченных заказов за этот месяц (paid_at).',
    helpCogs: 'Себестоимость еды (COGS) — стоимость ингредиентов проданного, построчно: рецепт каждого товара, выбранные порции и замены из модификаторов, а также средневзвешенные цены ингредиентов.',
    helpGross: 'Валовая прибыль = выручка − COGS. Постоянные затраты берутся из ваших ежемесячных записей и расходов из ящика (разменная касса) по сменам. Чистая прибыль = валовая прибыль − все постоянные затраты.',
    helpHow: 'Как рассчитывается {{title}}?',
    lineRevenue: 'Выручка',
    lineCogs: '− Себестоимость еды (COGS)',
    lineGross: '= Валовая прибыль',
    lineLabor: '− Фонд оплаты труда',
    lineRent: '− Аренда',
    lineUtilities: '− Коммунальные услуги',
    lineDrawer: '− Расходы из ящика',
    lineMarketing: '− Маркетинг',
    lineOther: '− Прочие постоянные',
    lineNet: '= Чистая прибыль',
    breakEven: 'Безубыточность и запас',
    fixedCosts: 'Постоянные затраты / месяц',
    revenueNeeded: 'Нужная выручка / день',
    coversNeeded: 'Нужно гостей / день',
    inventoryOnHand: 'Остатки на складе',
    inventoryDays: '~{{days}} дней',
    cashBalance: 'Остаток наличных',
    cashRunway: 'Запас наличных',
    cashRunwayValue: '~{{months}} месяцев',
    profitableNote: 'Прибыльно — остаток наличных растёт, если вы оставляете прибыль в деле.',
    monthlyCosts: 'Ежемесячные затраты и остаток наличных',
    monthlyHint: 'Введите постоянные затраты за этот месяц. Расходы из ящика подтягиваются автоматически из смен.',
    cashOnHand: 'Наличные на руках (֏)',
    catLabor: 'Оплата труда / зарплаты',
    catRent: 'Аренда',
    catUtilities: 'Коммунальные услуги',
    catMarketing: 'Маркетинг',
    catOther: 'Прочие постоянные',
    menuProfit: 'Прибыльность меню (по вкладу в прибыль)',
    colProduct: 'Товар',
    colType: 'Тип',
    colQty: 'Количество',
    colProfit: 'Прибыль',
    colMargin: 'Маржа',
    menuMatrix: 'Матрица меню',
    considerRemoving: 'Стоит убрать:',
    star: 'Звезда',
    workhorse: 'Рабочая лошадка',
    puzzle: 'Загадка',
    dog: 'Собака',
    starHint: 'Продолжайте продвигать — высокий объём и сильная маржа.',
    workhorseHint: 'Популярно, но маржа тонкая — рассмотрите небольшое повышение цены.',
    puzzleHint: 'Хорошая маржа, но мало продаж — продвигайте или перепозиционируйте.',
    dogHint: 'Низкий объём и низкая маржа — рассмотрите удаление.',
    popularity: 'Популярность',
    margin: 'Маржа',
    revenueByHour: 'Выручка по часам',
    revenueByWeekday: 'Выручка по дням недели',
    belowBreakEven: 'Дни с выручкой ниже {{amount}} могут не покрывать постоянные затраты.',
    costCogs: 'Себестоимость еды (COGS)',
    costLabor: 'Персонал',
    costRent: 'Аренда',
    costUtilities: 'Коммунальные',
    costDrawer: 'Расходы из кассы',
    costMarketing: 'Маркетинг',
    costOther: 'Прочие постоянные',
    ledgerCheck:
      'Сверка складского журнала: {{ledger}} против COGS по строкам заказов {{cogs}} (расхождение {{pct}}%).',
    ledgerWarn:
      ' Большой разрыв — часто устаревшие списания (например после смены единиц) или возвраты в другом месяце.',
    ledgerOk: ' Журнал и COGS по строкам заказов согласованы за этот месяц.',
    helpLedger:
      'Сверка складского журнала ниже сравнивает это с физическими списаниями остатков. Большие расхождения обычно означают старые данные или миграцию единиц — а не ошибку COGS в строке P&L.',
    helpCogsExtra:
      'Когда доступно, используется cogs_amd, зафиксированный при закрытии заказа; старые строки оцениваются по текущим рецептам.',
    helpMenuAgg: 'Одна строка на товар — все оплаченные позиции заказов за этот месяц.',
    helpMenuQty:
      'Кол-во — проданные единицы. Прибыль = выручка строки − COGS строки (та же логика, что себестоимость еды в P&L). Сортировка по прибыли — сначала крупнейшие вкладчики.',
    helpMenuMargin:
      'Маржа = прибыль ÷ выручка по товару. Тип (Звезда / Рабочая лошадка / Загадка / Собака) делит популярность и маржу по 50% — квадранты меню-инжиниринга.',
    helpMenuWine:
      'Для вина и товаров с выбором используется фактически проданная порция (из модификаторов заказа), а не теоретическое среднее.',
    sun: 'Вс',
    mon: 'Пн',
    tue: 'Вт',
    wed: 'Ср',
    thu: 'Чт',
    fri: 'Пт',
    sat: 'Сб',
  },
  stockIn: {
    title: 'Приход',
    subtitle: 'Управляйте заказами поставщикам и фиксируйте поставки ингредиентов.',
    newPurchase: 'Новая закупка',
    generateOrders: 'Сформировать заказы',
    undoToast: 'Заказ отмечен как отправленный.',
    noLines: 'Добавьте хотя бы один ингредиент с количеством больше 0.',
    duplicateIngredient: 'Каждый ингредиент может встречаться в поставке только один раз.',
    noLowStock: 'Сейчас нет ингредиентов ниже порога низкого остатка.',
    loadFailed: 'Не удалось загрузить',
    createFailed: 'Не удалось создать заказ поставщику.',
    undoTitle: 'Отменить закупку?',
    undoBody: 'Запись будет удалена, а остаток возвращён для:',
    undoLine: '{{name}}: −{{qty}} {{unit}}',
    undoConfirm: 'Отменить и вернуть остаток',
    cancelTitle: 'Отменить заказ?',
    cancelBody: 'Заказ будет отмечен как отменённый. Остатки не изменятся.',
    cancelConfirm: 'Отменить заказ',
    generateTitle: 'Сформировать заказы',
    generateIntro: '{{count}} ингредиентов ниже порога. Укажите поставщика и количество, затем сформируйте черновики заказов.',
    colIngredient: 'Ингредиент',
    colInStock: 'В наличии',
    colSupplier: 'Поставщик',
    colQtyToOrder: 'Количество к заказу',
    thresholdHint: 'порог: {{threshold}} {{unit}}',
    supplierNone: '— нет —',
    qtyPlaceholder: 'количество',
    needOne: 'Чтобы создать заказы, укажите поставщика и количество хотя бы для одного ингредиента.',
    createDrafts: 'Создать {{count}} черновиков заказов',
    pendingTitle: 'Ожидающие заказы',
    colStatus: 'Статус',
    colItems: 'Позиции',
    colCreated: 'Создан',
    colNote: 'Заметка',
    noSupplier: 'Нет поставщика',
    whatsapp: 'WhatsApp',
    whatsappTitle: 'Отправить {{name}} в WhatsApp',
    whatsappNoPhone: 'Добавьте телефон поставщика, чтобы включить WhatsApp',
    receive: 'Принять',
    receiveTitle: 'Подтвердить приём товара — обновит склад',
    cancelOrderTitle: 'Отменить этот заказ',
    confirmDelivery: 'Подтвердить поставку',
    captionReceive: 'Скорректируйте количества до фактически прибывших и подтвердите, чтобы добавить на склад.',
    captionNew: 'Зафиксируйте купленные ингредиенты. Остатки и себестоимость обновятся сразу после подтверждения.',
    footerLines: '{{count}} строк',
    footerTotal: ' · Итого {{amount}}',
    confirmReceipt: 'Подтвердить приём',
    confirmPurchase: 'Подтвердить закупку',
    supplier: 'Поставщик',
    note: 'Заметка',
    notePlaceholder: 'Номер накладной, детали поставки…',
    colQtyReceived: 'Принятое количество',
    colUnitCost: 'Цена за единицу (AMD)',
    typeIngredient: 'Введите ингредиент…',
    noMatch: 'Подходящего ингредиента нет',
    inStock: 'В наличии: {{stock}} {{unit}}',
    unitCostPlaceholder: 'Цена за единицу ֏',
    removeLine: 'Удалить строку',
    addIngredient: 'Добавить ингредиент',
    historyTitle: 'История закупок',
    purchaseCount: '{{count}} закупок',
    empty: 'Закупок ещё нет.',
    emptyRange: 'В выбранном периоде закупок нет.',
    colDate: 'Дата',
    colTotalCost: 'Общая стоимость',
    colAddedBy: 'Добавил',
    undoTitleRow: 'Отменить и вернуть остаток',
    statusDraft: 'черновик',
    statusSent: 'отправлен',
    statusReceived: 'принят',
    statusCancelled: 'отменён',
    csvDate: 'Дата',
    csvSupplier: 'Поставщик',
    csvIngredient: 'Ингредиент',
    csvQuantity: 'Количество',
    csvUnit: 'Единица',
    csvUnitCost: 'Цена за единицу (AMD)',
    csvLineTotal: 'Сумма строки (AMD)',
    csvAddedBy: 'Добавил',
    csvNote: 'Заметка',
  },
  prepBatches: {
    title: 'Заготовки партиями',
    subtitle: 'Зафиксируйте партию заготовки: списать сырьё, обновить остаток заготовки и перенести себестоимость партии в цену ингредиента заготовки.',
    recalcAll: 'Пересчитать все себестоимости заготовок',
    recalcTitle: 'Задать себестоимость каждой заготовки по рецептуре и текущим ценам сырья',
    recalcConfirm: 'Пересчитать себестоимость заготовок по текущим рецептам и ценам сырья? История партий и остатки не изменятся.',
    recalcUpdated: 'Обновлено {{count}}: {{list}}',
    recalcSkipped: 'Пропущено {{count}}: {{list}}',
    recalcNothing: 'Нечего обновлять.',
    recalcFailed: 'Пересчёт не удался',
    logPanel: 'Зафиксировать партию заготовки',
    selectRecipe: 'Выберите рецепт заготовки…',
    recipeOption: '{{name}} (выход {{yield}} {{unit}})',
    qtyPlaceholder: 'Произведённое количество',
    qtyWithUnit: 'Произведённое количество ({{unit}})',
    notePlaceholder: 'Заметка (необязательно)',
    previewTitle: 'Ингредиенты к списанию на {{qty}} {{unit}}',
    previewYield: '(количества в рецепте даны на {{yield}} {{unit}})',
    colIngredient: 'Ингредиент',
    colDeduct: 'Списать',
    colInStock: 'В наличии',
    low: 'низкий',
    subRecipeWarning: 'Подрецепты не раскрываются — добавьте их ингредиенты напрямую в этот рецепт заготовки.',
    insufficient: 'У части ингредиентов недостаточно остатка. Остаток будет ограничен нулём.',
    batchCost: 'Сырьевая себестоимость партии: {{raw}} → {{unitCost}}/{{unit}} готовой заготовки',
    missingCost: 'Нет сырьевой себестоимости: {{names}}',
    reviewConfirm: 'Проверить и подтвердить',
    confirmPrompt: 'Зафиксировать {{qty}} {{unit}} {{name}}?',
    confirm: 'Подтвердить',
    success: 'Зафиксировано {{qty}} {{unit}} {{name}}',
    logFailed: 'Не удалось зафиксировать партию',
    emptyRecipes: 'Рецептов заготовок ещё нет. Откройте «Рецепты» и включите рецепт как заготовку.',
    recipesLink: 'Рецепты',
    historyTitle: 'История партий',
    empty: 'Партий ещё нет.',
    colDate: 'Дата',
    colPrep: 'Заготовка',
    colQty: 'Произведено',
    colBy: 'Кто',
    colNote: 'Заметка',
  },
  modifiers: {
    title: 'Модификаторы',
    subtitle: 'Добавьте выбираемые опции к товарам — лёд, с собой, дополнительный шот и т. д. Привязывайте каждую группу только к нужным товарам.',
    howTitle: 'Как работают модификаторы',
    step1: 'Создайте группу — например, Приготовление (мин. 0, макс. 1 = необязательно) или Подача (мин. 1, макс. 1 = кассир обязан выбрать).',
    step2: 'Добавьте опции — например, Без льда, Больше льда, С собой, В зале.',
    step3: 'Привяжите к товарам — без привязки группа на товаре не появится.',
    footer: 'Выбранные опции печатаются на чеке и кухонном тикете. Цена = базовый товар + дельты опций.',
    addGroup: 'Добавить группу модификаторов',
    namePlaceholder: 'Название группы (например, Сорт зерна)',
    min: 'Минимум',
    max: 'Максимум',
    submit: 'Добавить группу',
    groupNameRequired: 'Название группы обязательно.',
    optionNameRequired: 'Название опции обязательно.',
    deleteConfirm: 'Удалить эту группу модификаторов и все её опции?',
    empty: 'Групп модификаторов ещё нет. Создайте группу выше.',
    pickRule: 'выбор {{rule}}',
    required: ' (обязательно)',
    optional: ' (необязательно)',
    options: 'Опции',
    optionName: 'Название опции',
    deltaKind: 'Изменение цены',
    kindFixed: '֏',
    kindPercent: '%',
    deltaPlaceholder: 'Драмы, например 1500 или -200',
    deltaPlaceholderPercent: 'Процент, например 10 или -10',
    deltaInvalid: 'Введите число. Для скидки используйте минус.',
    addOption: 'Добавить опцию',
    noOptions: 'Опций ещё нет.',
    colOption: 'Опция',
    colPriceDelta: 'Дельта цены',
    attached: 'Привязанные товары',
    noAttached: 'Товары ещё не привязаны.',
    attachPlaceholder: '+ Привязать товар…',
    removeTitle: 'Убрать {{name}}',
  },
  loyalty: {
    title: 'Лояльность',
    subtitleDisabled: 'Баллы + карты участника Apple/Google Wallet.',
    subtitleEnabled: 'Начисляйте и списывайте {{pointName}}, скидки участников и карты кошелька с номерами клиентов.',
    notAvailableTitle: 'Пока недоступно',
    notAvailableBody: 'Программа лояльности для вашего кафе ещё не включена. Попросите администратора Orio включить её.',
    settings: 'Настройки программы',
    enable: 'Включить программу лояльности',
    earnRate: 'Курс начисления',
    earnHint: 'AMD, потраченные чтобы заработать 1 балл.',
    redeemRate: 'Курс списания',
    redeemHint: 'AMD скидки за 1 балл. Держите заметно ниже курса начисления.',
    rateSummary: 'Сводка курсов',
    hideRateSummary: 'Скрыть сводку курсов',
    saveSettings: 'Сохранить настройки',
    saved: 'Сохранено.',
    notProvisioned: 'Лояльность для этого кафе не подключена — обратитесь к администратору.',
    exampleTitle: 'Пример с текущими курсами',
    exampleSpend: 'Гость тратит {{amount}} → получает {{coins}} {{pointName}} (1 за {{earnRate}} AMD).',
    walletTitle: 'Оформление карты кошелька',
    logoText: 'Текст логотипа карты',
    logoPlaceholder: 'Название кафе',
    logoHint: 'Показывается вверху карты Apple/Google Wallet.',
    passColor: 'Цвет карты',
    colorApply: 'Применяется к новым картам. Существующие карты сохраняют оформление.',
    saveDesign: 'Сохранить оформление',
    colorDark: 'тёмный',
    colorBlue: 'синий',
    colorGreen: 'зелёный',
    colorRed: 'красный',
    colorPurple: 'фиолетовый',
    colorOrange: 'оранжевый',
    linksTitle: 'Ссылки для регистрации',
    newLink: '+ Новая ссылка',
    namePlaceholder: 'Название (например, VIP-уровень)',
    collectPoints: 'Копить баллы',
    customNumber: 'Свой #',
    add: 'Добавить',
    discountByCategory: 'Скидка по категории меню',
    collect: 'Копить',
    custom: 'Свой',
    colName: 'Название',
    colDiscount: 'Скидка',
    colPoints: 'Баллы',
    colCustomNumber: 'Свой #',
    colLink: 'Ссылка',
    colStatus: 'Статус',
    copyLink: 'Копировать ссылку',
    disableTitle: 'Нажмите, чтобы закрыть регистрацию',
    enableTitle: 'Нажмите, чтобы снова включить',
    emptyLinks: 'Ссылок ещё нет. Создайте ссылку, чтобы гости могли вступить.',
    created: 'Ссылка для регистрации создана.',
    updated: 'Ссылка обновлена. Новые участники получат новые условия; текущие сохранят свои.',
    duplicateName: 'Ссылка с таким названием уже есть.',
    noCategories: 'Категорий меню ещё нет.',
    allCategories: 'Все категории',
    mixed: 'Смешанная',
    membersTitle: 'Участники ({{filtered}})',
    removeSelected: 'Удалить выбранных ({{count}})',
    addMember: '+ Добавить участника',
    source: 'Источник',
    allSources: 'Все источники',
    manual: 'Вручную',
    linkRemoved: 'Ссылка удалена',
    phoneOptional: 'Телефон (необязательно)',
    create: 'Создать',
    enterName: 'Введите имя участника.',
    memberCreated: 'Участник создан.',
    emptyMembers: 'Участников ещё нет.',
    emptyFilter: 'Нет участников по этому источнику.',
    qr: 'QR',
    remove: 'Удалить',
    colCustomerNumber: 'Номер клиента',
    colEarnsPoints: 'Копит баллы',
    colWallet: 'Кошелёк',
    colJoined: 'Вступил',
    qrTitle: 'QR участника',
    qrBody: 'Номер клиента {{code}} — карты кошелька нет. Распечатайте или отправьте этот QR для поиска на POS.',
    actionsAria: 'Действия',
    linkNameAria: 'Название ссылки',
    memberNameAria: 'Имя участника',
    selectAllAria: 'Выбрать всех видимых участников',
    selectMemberAria: 'Выбрать {{name}}',
    customNumberTitle: 'Регистрирующиеся могут выбрать свой номер клиента (1000+)',
    uniqueCodeFailed: 'Не удалось создать уникальный номер клиента. Попробуйте снова.',
    manualMembersNote: 'Участники, добавленные вручную, получают только номер клиента и QR — без карты кошелька.',
    discountPercentAria: 'Процент скидки для {{name}}',
    editDiscounts: 'Измените скидки по категориям ниже',
    cardTitleAlways: 'Название карты всегда {{title}}.',
    balanceShown: 'Баланс показывается как {{name}}.',
  },
  loyaltyJoin: {
    pageTitle: 'Вступить в программу',
    pageTitleCafe: 'Вступить в программу — {{cafeName}}',
    unavailable: 'Регистрация временно недоступна.',
    notConfigured: 'Приложение не настроено.',
    incompleteLink: 'Эта ссылка неполная. Попросите в кафе полную ссылку программы.',
    loadFailed: 'Не удалось загрузить кафе.',
    cafeNotFound: 'Кафе не найдено.',
    notAvailable: 'Лояльность для этого кафе пока недоступна.',
    notOpen: 'Регистрация в программе ещё не открыта — загляните позже.',
    invalidLink: 'Эта ссылка недействительна или отключена.',
    loadPageFailed: 'Не удалось загрузить страницу регистрации.',
    enterName: 'Введите ваше имя.',
    enrollNotConfigured: 'Регистрация на сервере ещё не настроена.',
    noWalletLink: 'Ссылка на кошелёк не получена. Попробуйте снова или обратитесь в кафе.',
    signupFailed: 'Регистрация не удалась.',
    youGet: 'Вы получаете {{benefit}}. ',
    earnPoints: 'Копите {{pointName}} при оплате — 1 за каждые {{earnRate}} AMD.',
    discountOnly: 'Это членство не копит баллы — только скидка.',
    successTitle: 'Добавьте в кошелёк',
    customerNumber: 'Ваш номер клиента: {{code}}',
    savePass: 'Сохраните карту ниже — в ней ваш QR-код.',
    addWallet: 'Добавить в Apple / Google Wallet',
    defaultTitle: 'Вступить в программу',
    nameLabel: 'Ваше имя',
    namePlaceholder: 'Имя и фамилия',
    phoneLabel: 'Телефон (необязательно)',
    phonePlaceholder: '91 123456',
    phoneAria: 'Номер телефона без кода страны',
    customNumberLabel: 'Номер клиента (необязательно, {{min}}+)',
    customNumberPlaceholder: 'Оставьте пустым для авто, или напр. {{min}}',
    signingUp: 'Регистрация…',
    signUp: 'Зарегистрироваться',
    leadPoints: 'Цифровая карта кошелька с вашим номером клиента. Копите баллы при каждом визите.',
    leadDiscount: 'Цифровая карта кошелька с вашим номером клиента и скидками участника.',
    plus: ' плюс ',
    pctOffCategory: '{{pct}}% скидка на {{name}}',
    upToOff: 'До {{pct}}% скидки на выбранные категории',
    pctOffEvery: '{{pct}}% скидка при каждом визите',
  },
  settings: {
    title: 'Настройки',
    taxTitle: 'Доступ к Налоговой службе Армении',
    taxIntro: 'Хранятся в вашем аккаунте и используются для загрузки накладных. Просматривать и менять их можете только вы (владелец).',
    tin: 'TIN (идентификатор налогоплательщика)',
    tinPlaceholder: 'например, 08319907',
    username: 'Имя пользователя',
    usernamePlaceholder: 'Логин налоговой службы',
    password: 'Пароль',
    activeToken: 'Действующий токен налоговой службы',
    tokenHint: 'Это JWT для запросов к налоговой службе. Он общий для всех устройств, вошедших в этот аккаунт.',
    saved: 'Сохранено.',
    posTitle: 'Пароль устройства POS',
    posIntro: 'Введите этот пароль один раз на новом POS, чтобы привязать его. Устройство запомнит кафе и список кассиров — дальше кассирам нужен только PIN.',
    posPassword: 'Пароль',
    posPlaceholder: 'Задайте пароль POS…',
    generate: 'Сгенерировать',
  },
  users: {
    title: 'Пользователи',
    subtitle: 'Создавайте аккаунты панели для сотрудников, которые помогают вести бизнес.',
    rolesTitle: 'Доступ по ролям',
    roleAdmin: 'Администратор — Аналитика, Заказы, Смены, Меню, Ингредиенты, Рецепты, Чек, Накладные',
    roleManager: 'Менеджер — Заказы, Смены, Меню, Ингредиенты, Рецепты, Чек, Накладные (без аналитики)',
    roleAccountant: 'Бухгалтер — только книги. Может скачать пакет для ArmSoft. Операции менять не может.',
    rolesFooter: 'Ни одна из этих ролей не имеет доступа к Пользователям, Кассирам и Настройкам.',
    createTitle: 'Создать пользователя',
    emailPlaceholder: 'Адрес электронной почты',
    namePlaceholder: 'Имя и фамилия (необязательно)',
    roleManagerOpt: 'Менеджер',
    roleAdminOpt: 'Администратор',
    roleAccountantOpt: 'Бухгалтер',
    submit: 'Создать пользователя',
    emailRequired: 'Электронная почта обязательна.',
    credsTitle: 'Данные нового пользователя',
    credsNote: 'Скопируйте и отправьте пользователю. Пароль показывается только один раз.',
    email: 'Электронная почта',
    password: 'Пароль',
    emptyTitle: 'Пользователей ещё нет',
    empty: 'Пользователей ещё нет. Создайте выше.',
    count: '{{count}} пользователей',
    colFullName: 'Имя и фамилия',
    colEmail: 'Электронная почта',
    colRole: 'Роль',
    colCreated: 'Создан',
    resetPassword: 'Сбросить пароль',
    resetCreds: 'Новые данные — отправьте пользователю, показываются один раз:',
    resetting: 'Сброс…',
    copyEmail: 'Копировать email',
    copyPassword: 'Копировать пароль',
    copied: 'Скопировано',
  },
  clients: {
    title: 'Клиенты',
    subtitle: 'Создайте кафе/ресторан и аккаунт владельца.',
    newTitle: 'Новый клиент',
    cafeName: 'Название кафе',
    cafePlaceholder: 'Demo Cafe',
    ownerEmail: 'Почта владельца',
    ownerEmailPlaceholder: 'owner@cafe.com',
    ownerName: 'Имя владельца',
    ownerNamePlaceholder: 'Имя и фамилия',
    submit: 'Создать клиента',
    required: 'Название кафе и почта владельца обязательны.',
    credsTitle: '{{name}} — данные владельца',
    credsNote: 'Скопируйте и отправьте владельцу. Показываются только один раз.',
    copyCreds: 'Копировать данные',
    allClients: 'Все клиенты',
    emptyTitle: 'Клиентов ещё нет',
    empty: 'Создайте первое кафе выше.',
    colCafe: 'Кафе',
    colOwnerEmail: 'Почта владельца',
    colLoyalty: 'Лояльность',
    colTableService: 'Обслуживание за столами',
    colBookings: 'Бронирования',
    colWalletPasses: 'Карты кошелька',
    colActive: 'Активен',
    colCreated: 'Создан',
    rename: 'Переименовать',
    rowActions: 'Действия',
    newPassword: 'Новый пароль',
    resetConfirm: 'Сбросить пароль владельца для {{name}}? Текущий пароль сразу перестанет действовать.',
    resetYes: 'Да, сбросить',
    resetFailed: 'Сброс не удался',
    statsActiveToday: 'Продают сегодня',
    statsActiveSub: '{{selling}} из {{total}} активных',
    statsOrdersToday: 'Заказы сегодня',
    statsQuiet: 'Тихие кафе',
    statsQuietSub: 'Нет заказа 3 дня',
    statsForce30: 'Принудительно закрыто, 30 дней',
    statsRevenue30: 'Выручка, 30 дней',
    colLastOrder: 'Последний заказ',
    colOrders30: 'Заказы, 30 дней',
    colRegisters: 'Кассы',
    openStats: 'Открыть использование',
    freshToday: 'Сегодня',
    freshYesterday: 'Вчера',
    freshDays: '{{n}} дн. назад',
    freshNever: 'Нет заказов',
    versionNone: 'Пока нет',
    versionCount: '{{version}} × {{n}}',
    sectionActivity: 'Активность',
    sectionHealth: 'Состояние',
    sectionUsage: 'Использование',
    sectionRegisters: 'Кассы',
    ordersToday: 'Заказы сегодня',
    orders7: 'Заказы, 7 дней',
    orders30: 'Заказы, 30 дней',
    openShifts: 'Открытые смены',
    lastShift: 'Последняя смена открыта',
    lastSignIn: 'Последний вход',
    force30: 'Принудительно закрыто, 30 дней',
    forceSystem: 'Оплачен, ошибка системы',
    forceMistake: 'Ошибка',
    forceFree: 'Бесплатно',
    forceOther: 'Другая причина',
    paidNoFiscal: 'Оплачен, без фискального чека',
    paidNoPayment: 'Оплачен, без строки оплаты',
    diagnostics30: 'Диагностики, 30 дней',
    cashiers: 'Кассиры',
    dashboardUsers: 'Пользователи панели',
    products: 'Товары в меню',
    categories: 'Категории',
    ingredients: 'Ингредиенты',
    recipes: 'Рецепты',
    loyaltyMembers: 'Участники лояльности',
    bookingsMonth: 'Бронирования в этом месяце',
    invoicesMonth: 'Счета в этом месяце',
    revenue30: 'Выручка, 30 дней',
    registersEmpty: 'Касса ещё не отмечалась. Появится после следующего обновления POS.',
    colVersion: 'Версия',
    colPlatform: 'Платформа',
    colLastSeen: 'Был на связи',
    colPending: 'Ждёт отправки',
    colLastGap: 'Последняя тишина',
    colOffline30: 'Офлайн, 30 дней',
    seenJustNow: 'Только что',
    seenMinutes: '{{n}} мин назад',
    seenHours: '{{n}} ч назад',
    seenDays: '{{n}} дн. назад',
    minutesShort: '{{n}} мин',
    hoursShort: '{{n}} ч',
    hoursMinutes: '{{hours}} ч {{minutes}} мин',
    platformMacos: 'Mac',
    platformWindows: 'Windows',
    platformWeb: 'Браузер',
    platformDesktop: 'Компьютер',
    never: 'Никогда',
  },
  invoices: {
    title: 'Накладные',
    subtitle: 'Налоговые накладные поставщиков из Налоговой службы. Проверяйте, классифицируйте и утверждайте их внутри.',
    connecting: 'Подключение…',
    loadingCount: 'Загрузка… {{count}}',
    tokenMissing: 'Доступ к Налоговой службе не задан — добавьте его в Настройках.',
    invoiceCount: '{{count}} накладных',
    total: 'Итого {{amount}}',
    supplierSummary: 'Сводка по поставщикам →',
    supplier: 'Поставщик',
    supplierTin: 'ИНН поставщика',
    serial: 'Серийный номер',
    category: 'Категория',
    include: 'Включить',
    exclude: 'Исключить',
    selectAll: 'Выбрать все',
    clear: 'Очистить',
    minTotal: 'Минимальная сумма ֏',
    taxStatusAll: 'Налоговый статус: все',
    taxIssued: 'Выставлена',
    taxApproved: 'Подтверждена',
    internalAll: 'Внутренний: все',
    pending: 'Ожидает',
    approved: 'Утверждена',
    reverted: 'Отменена',
    approvedByAll: 'Утвердил: кто угодно',
    reset: 'Сбросить',
    noMatchTitle: 'Нет накладных по этим фильтрам',
    noMatchText: 'Ослабьте фильтр или сбросьте их, чтобы увидеть всё за период.',
    resetFilters: 'Сбросить фильтры',
    colNum: '#',
    colSerial: 'Серия',
    colSupplier: 'Поставщик',
    colCategory: 'Категория',
    colDate: 'Дата',
    colTotal: 'Итого',
    colTaxStatus: 'Налоговый статус',
    colInternal: 'Внутренний',
    colApprovedBy: 'Утвердил',
    uncategorised: 'Без категории',
    review: 'Проверить',
    revert: 'Отменить',
    revertConfirm: 'Отменить?',
    emptyTitle: 'В этом периоде накладных нет',
    emptyText: 'Выберите более широкий период или проверьте, что доступ к Налоговой службе в Настройках ещё действителен.',
    reviewTitle: 'Проверка накладной',
    approveHint: 'Внутреннее утверждение обновляет остатки ингредиентов. Статус в Налоговой службе не меняется.',
    loadingGoods: 'Загрузка товаров…',
    colGoodsName: 'Название товара (из накладной)',
    colInvoiceQty: 'Количество в накладной',
    colInvoicePrice: 'Цена в накладной',
    colRecordAs: 'Записать как',
    colUnit: 'Единица',
    colPrice: 'Цена',
    colLinkIngredient: 'Связать с ингредиентом',
    existing: 'Существующий',
    createNew: 'Создать новый',
    selectIngredient: '— выбрать ингредиент —',
    ingredientName: 'Название ингредиента',
    addIngredient: '+ Добавить ингредиент',
    noLineItems: 'Отдельных строк нет — утвердите на уровне накладной.',
    alreadyApproved: 'Эта накладная уже {{status}} — дополнительных действий не нужно.',
    approveInternal: 'Утвердить внутри',
    confirmPrompt: 'Это зафиксирует поставку на склад и не может быть отменено. Подтвердить?',
    approvalNote: 'Комментарий к утверждению (необязательно)',
    yesApprove: 'Да, утвердить',
    approvedMsg: 'Утверждено!',
    csvSupplierTin: 'ИНН поставщика',
    csvTotalAmd: 'Итого (AMD)',
    csvInternalStatus: 'Внутренний статус',
    csvApprovedAt: 'Утверждено',
    revertedBy: 'Отменил {{name}}',
    metaNote: 'Примечание',
    metaTotal: 'Итого',
    metaVat: 'НДС',
    metaTax: 'Налог',
    delivery: 'Доставка',
    authPerson: 'Уполномоченный',
    shipFrom: 'Откуда',
    shipTo: 'Куда',
    colTrack: 'Учёт',
    trackTitle: 'Учитывать эту позицию на складе',
    useSingle: 'Один ингредиент',
    splitAcross: 'Разделить по ингредиентам',
    splitQty: 'Разделено: {{sum}} / {{qty}} в накладной',
    lastPrice: 'Прошлая',
    ingredientCount: '{{count}} ингредиент(ов)',
    qtyPlaceholder: 'Кол-во',
    splitIngredient: '— ингредиент —',
    splitNew: 'Новый',
    newIngredientName: 'Название нового ингредиента',
    removeSplit: 'Убрать',
    trackRequired: 'Все учитываемые строки должны быть связаны с ингредиентом (или пропущены)',
    approvalNotePlaceholder: 'напр. частичная поставка, проверка цены…',
    credentialsMissing: 'Доступ к Налоговой службе не настроен. Добавьте его в Настройках.',
    taxSessionActive:
      'Ошибка Налоговой службы 0032: предыдущий сеанс ещё активен. Подождите несколько минут и обновите страницу.',
  },
  purchases: {
    title: 'Закупки',
    subtitle: 'Расходы по утверждённым электронным накладным в разрезе категорий поставщиков. Категории задаются в Поставщиках или Накладных.',
    loadFailed: 'Не удалось загрузить закупки',
    couldntLoad: 'Не удалось загрузить закупки',
    totalSpend: 'Общие расходы',
    approvedInvoices: 'Утверждённые накладные',
    suppliers: 'Поставщики',
    chartTitle: 'Ежемесячные расходы по категориям',
    nothingToChart: 'Нечего показать на графике',
    bySupplier: 'Расходы по поставщикам',
    noSuppliers: 'Поставщиков ещё нет',
    colInvoices: 'Накладные',
    colSpend: 'Расход',
    colShare: 'Доля',
    uncategorized: 'Без категории',
    emptyPeriod: 'В этом периоде утверждённых накладных нет.',
    openSummary: 'Открыть сводку закупок',
  },
  supplierDetail: {
    viewInvoices: 'Смотреть накладные',
    loadFailed: 'Не удалось загрузить закупки поставщика',
    totalSpend: 'Общие расходы',
    approvedInvoices: 'Утверждённые накладные',
    itemsSupplied: 'Поставленные позиции',
    empty: 'В выбранном периоде нет утверждённых накладных этого поставщика.',
    colItem: 'Позиция',
    colQuantity: 'Количество',
    colInvoices: 'Накладные',
    colAvgPrice: 'Средняя цена',
    colLastPrice: 'Последняя цена',
    colTrend: 'Динамика',
    colSpend: 'Расход',
    colShare: 'Доля',
    untracked: 'без учёта',
    tinPrefix: 'TIN {{tin}}',
  },
  settingsPage: {},
  wasteLog: {
    newEntry: 'Новая запись',
    newCaption: 'Остаток уменьшается сразу.',
    compRecipient: 'Получатель комплимента',
    commentRequired: 'Добавьте комментарий для пункта «Другое».',
    commentPlaceholder: 'Комментарий обязателен',
    selectRecipient: 'Выберите имя…',
    recipientRequired: 'Выберите, кому это питание сотрудника.',
    cancelEntry: 'Отменить запись',
    editTitle: 'Изменить списание',
    quantity: 'Количество',
    reason: 'Причина',
    note: 'Заметка',
    cancelTitle: 'Отменить эту запись списания?',
    cancelMessage: 'Вернуть {{qty}} {{unit}} {{name}} на склад. Это нельзя отменить.',
    cancelled: 'Отменено',
    cancelling: 'Отмена…',
  },
  stockCount: {
    revertModalTitle: 'Отменить инвентаризацию',
    revertModalBody: 'Отменяет влияние этой инвентаризации на текущий остаток ({{delta}} {{unit}} будет возвращено). Оригинал останется в истории, но не войдёт в метрики потерь.',
    ingredient: 'Ингредиент',
    countDate: 'Дата инвентаризации',
    countDelta: 'Дельта инвентаризации',
    currentStock: 'Текущий остаток',
    afterRevert: 'После отмены',
    reasonOptional: 'Причина (необязательно)',
    reasonPlaceholder: 'например, введено неверное количество',
    confirmRevert: 'Отменить инвентаризацию',
  },
  cashiers: {
    addPanel: 'Добавить кассира',
    hdmPlaceholder: 'Номер HDM',
    hdmCol: 'Номер HDM',
    hdmShort: 'HDM',
    username: 'Имя пользователя',
    pin: 'PIN',
    newPinPlaceholder: 'новый PIN',
    colUsername: 'Имя пользователя',
    colName: 'Имя',
    colLastSeen: 'Последний вход',
    deleteConfirm: 'Удалить этого кассира? Это нельзя отменить.',
    pinInvalid: 'PIN должен состоять ровно из 4 цифр.',
    usernameRequired: 'Имя пользователя обязательно.',
    empty: 'Кассиров ещё нет.',
    resetPin: 'Сбросить PIN',
  },
  menu: {
    noClient: 'Для этого аккаунта нет контекста клиента.',
    categoryNameRequired: 'Название категории обязательно.',
    hdmDeptInvalid: 'Отдел HDM должен быть целым числом ≥ 1.',
    deleteCategoryConfirm: 'Удалить эту категорию? Товары в ней потеряют категорию.',
    productRequired: 'Название, категория и цена обязательны.',
    importNoRows: 'Подходящих строк нет (в каждой нужны название, категория с отделом HDM и цена).',
    imported: 'Импортировано товаров: {{count}}.',
    namePlaceholder: 'Название',
    sortPlaceholder: 'Порядок',
    hdmPlaceholder: 'Отдел HDM *',
    hdmTitle: 'Идентификатор фискального отдела HDM (должен совпадать с устройством)',
    printKitchen: 'Печать на кухню',
    colName: 'Название',
    colOrder: 'Порядок',
    colHdm: 'Отдел HDM',
    colKitchen: 'Кухня',
    colRegister: 'Касса',
    hideFromRegister: 'Скрыть с кассы',
    showOnRegister: 'Показать на кассе',
    confirmHideTitle: 'Скрыть {{name}} с кассы?',
    confirmHideBody: 'Категория пропадёт с кассы и из поиска. В меню она останется.',
    confirmShowTitle: 'Показать {{name}} на кассе?',
    confirmShowBody: 'Категория снова появится на кассе.',
    noCategories: 'Категорий ещё нет. Добавьте выше.',
    categoryPlaceholder: 'Категория…',
    pricePlaceholder: 'Цена',
    unitPlaceholder: 'Единица',
    adgPlaceholder: 'Код ADG',
    codePlaceholder: 'Код',
    noRecipe: 'Нет рецепта',
    colProduct: 'Товар',
    colCategory: 'Категория',
    colPrice: 'Цена',
    colUnit: 'Единица',
    colAdg: 'ADG',
    colRecipe: 'Рецепт',
    colCost: 'Себестоимость',
    colStatus: 'Статус',
    noProducts: 'Товаров ещё нет. Сначала добавьте категории, затем товары.',
    noSearchMatch: 'Нет товаров по запросу «{{query}}».',
    emptyCategory: 'В этой категории нет товаров.',
    importHint: 'Столбцы: name, category, price, unit, adg_code, code',
    deptColorTitle: 'Цвет вкладки POS для отдела {{id}}',
  },
  ingredients: {
    exportCsv: 'Экспорт CSV',
    copy: 'Дублировать',
    noClient: 'Нет контекста клиента.',
    nameRequired: 'Название обязательно.',
    invalidNumber: 'Введите корректное число.',
    invalidNonNegative: 'Введите корректное неотрицательное число.',
    invalidDelta: 'Введите ненулевое изменение (отрицательное — для списания).',
    namePlaceholder: 'Название',
    lowStockPlaceholder: 'Оповещение о низком остатке',
    costPlaceholder: 'Себестоимость (AMD)',
    openingStockPlaceholder: 'Начальный остаток',
    colReorder: 'Количество к заказу',
    colValue: 'Стоимость',
    prep: 'Заготовка',
    changeUnit: 'Сменить единицу',
    historyTitle: 'История — {{name}}',
    openInvoice: 'Открыть накладную',
    invoiceMissing: 'Этой накладной больше нет.',
    suppliers: 'Поставщики:',
    noSuppliers: 'Не указаны',
    noTx: 'Операций ещё нет.',
    goToStockIn: 'Перейти к приходу →',
    markActive: 'Сделать активным',
    markInactive: 'Сделать неактивным',
    viewHistory: 'Смотреть историю',
    lowStockBanner: '{{count}} ингредиент(ов) ниже порога:',
    moreCount: ' +ещё {{count}}',
    set: 'Задать',
    newValuePlaceholder: 'новое значение',
    adjustQtyPlaceholder: '±кол-во',
    notePlaceholder: 'заметка',
    ok: 'OK',
    adjustTitle: 'Корректировка (списание / исправление)',
    prepManaged: 'Управляется партиями заготовок',
    prepManagedHint: 'Управляется через партии заготовок — правьте как админ/владелец',
    csvHint:
      'Столбцы: name, unit, stock, low_stock_threshold, cost_price (строка заголовка необязательна)',
    deleteTitle: 'Удалить ингредиент?',
    deleteBody: 'Удалить {{name}}? Это нельзя отменить.',
    checking: 'Проверка…',
    cannotDeleteTitle: 'Нельзя удалить «{{name}}»',
    cannotDeleteBody:
      'Этот ингредиент всё ещё используется в следующих местах. Уберите его оттуда перед удалением.',
    changeUnitTitle: 'Сменить единицу — {{name}}',
    newUnit: 'Новая единица',
    conversionLabel: 'Пересчёт — 1 {{newUnit}} = сколько {{oldUnit}}?',
    conversionHint: 'оставьте 1 для простого переименования единицы без пересчёта',
    previewChanges: 'Предпросмотр изменений',
    field: 'Поле',
    current: 'Сейчас',
    newCol: '→ Новое',
    costPriceField: 'Себестоимость',
    recipeLine: 'Рецепт: {{name}}',
    choiceLine: 'Выбор: {{name}}',
    ledgerRepairNote:
      'Только ремонт журнала — остаток и рецепты без изменений. Крупные устаревшие количества (масштаб мл, ≥ ratio ÷ 4) делятся на {{ratio}}; мелкие строки уже в {{unit}} (например, недавние +20 пополнения, −1 продажи) не меняются.',
    convertNote:
      'Остаток, рецепты, себестоимость и вся история складских операций пересчитываются по этому коэффициенту. Используйте ремонт журнала (та же единица + коэффициент), если единицу уже сменили, а итоги списаний всё ещё неверны.',
    positiveRatio: 'Введите положительный коэффициент пересчёта.',
    confirmApply: 'Это обновит все значения выше. Продолжить?',
    yesApply: 'Да, применить',
    renameTo: 'Переименовать в «{{unit}}»',
    repairLedgerBtn: 'Починить журнал ({{unit}})',
    convertTo: 'Перевести в {{unit}}',
    colTime: 'Время',
    colType: 'Тип',
    colDelta: 'Изменение',
    colReference: 'Ссылка',
    colNote: 'Заметка',
    historyPageTotal: '{{total}} всего',
    unitChangeFailed: 'Не удалось сменить единицу',
    noValidRows: 'Подходящих строк не найдено.',
    imported: 'Импортировано ингредиентов: {{count}}.',
    inStockSuffix: '{{stock}} в наличии',
    blockRecipe: 'Рецепт: «{{name}}»',
    blockSubstitute: 'Вариант замены в рецепте: «{{name}}»',
    blockPoItems: '{{count}} позиций в заказах поставщикам',
    csvName: 'Название',
    csvUnit: 'Единица',
    csvStock: 'Остаток',
    csvLowStock: 'Порог низкого остатка',
    csvReorder: 'Количество к заказу',
    csvCost: 'Себестоимость (AMD)',
    csvValue: 'Стоимость (AMD)',
    csvActive: 'Активен',
    csvYes: 'да',
    csvNo: 'нет',
  },
  recipes: {
    cardNameRequired: 'Название карточки обязательно.',
    failed: 'Не удалось',
    deleteConfirm: 'Удалить рецепт «{{name}}»? Это нельзя отменить.',
    saveName: 'Сохранить название',
    newTitle: 'Новый рецепт',
    newCaption: 'Дайте название, затем добавьте ингредиенты в редакторе.',
    name: 'Название',
    batchYield: 'Выход партии',
    unit: 'Единица',
    prepRecipe: 'Рецепт заготовки',
    prepHint: 'готовится партиями и хранится как ингредиент',
    yieldPlaceholder: 'напр. 1.5',
    unitPlaceholder: 'Единица…',
    noMatch: 'Нет рецептов по запросу «{{query}}».',
    noMatchTitle: 'Рецептов ещё нет',
    noMatchText: 'Создайте рецепт, чтобы списывать остатки с каждой продажи.',
    rename: 'Переименовать',
    delete: 'Удалить',
    prep: 'Заготовка',
    back: 'Назад',
    selectTitle: 'Выберите рецепт',
    soldDirectly: '· продаётся напрямую',
    ingredientsTitle: 'Ингредиенты',
    emptyTitle: 'Ингредиентов ещё нет',
    emptyText: 'Добавьте первую строку ниже. Остаток списывается с этих позиций при каждой продаже.',
    choiceTitle: 'Группа выбора',
    addChoice: 'Добавить группу выбора',
    pickOne: 'Выберите один',
    choiceMode: 'Как добавлять выборы',
    choiceModeSeparate: 'Отдельные позиции',
    choiceModeCombine: 'На этом блюде',
    choiceModeSeparateHint: 'Каждый выбор — отдельная строка: бокал вина, бутылка.',
    choiceModeCombineHint: 'Выборы остаются на этом блюде: сырная тарелка.',
    choiceMin: 'Мин.',
    choiceMax: 'Макс.',
    choiceMaxNone: 'Без лимита',
    yield: 'Выход',
    substitutePlaceholder: 'Заменяющий ингредиент…',
    pricePlus: '+ цена ֏',
    deleteRecipe: 'Удалить рецепт',
    editSubstitute: 'Изменить замену',
    removeSubstitute: 'Убрать замену',
    editLine: 'Изменить строку',
    qty: 'Кол-во',
    choiceHint: 'Кассир выбирает эти ингредиенты на POS. Отдельные позиции = вино. На этом блюде = сырная тарелка.',
    editDeduction: 'Изменить списываемое количество',
    removeOption: 'Убрать вариант',
    ingredientPlaceholder: 'Ингредиент…',
    searchIngredient: 'Найти ингредиент…',
    ingredientNoMatch: 'Ингредиенты не найдены',
    qtyPerBatch: 'Кол-во на партию',
    makePrep: 'Сделать рецептом заготовки',
    saveForSubstitutes: 'Сохраните, чтобы управлять заменами',
    deleteGroup: 'Удалить группу',
    noOptions: 'Вариантов пока нет.',
    addOption: 'Добавить вариант',
    yields: 'Выход',
    linkedAuto: 'связанный ингредиент ведётся автоматически',
    autosaved: 'Сохранено',
  },
  bookings: {
    prevMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
    notePlaceholder: 'Поздний заезд, аллергии, особые пожелания…',
    couldntLoad: 'Не удалось загрузить аналитику бронирований',
  },
  rooms: {
    pricePlaceholder: 'AMD / ночь',
  },
  suppliers: {
    openSummary: 'Открыть сводку закупок',
    phonePlaceholder: '+374 XX XXX XXX',
  },
  staffComps: {
    couldntLoad: 'Не удалось загрузить служебные компенсации',
  },
  customerDisplay: {
    joinPlaceholder: 'https://yoursite.com/join/…',
  },
  managers: {
    title: 'Менеджеры',
    subtitle: 'Создайте учётные записи для сотрудников, которые ведут операции, но не владеют бизнесом.',
    accessTitle: 'Доступ менеджера',
    canAccess: 'Доступно:',
    canAccessList: 'Заказы, Смены, Меню, Ингредиенты, Техкарты, Чек',
    cannotAccess: 'Недоступно:',
    cannotAccessList: 'Аналитика (Панель, Продажи, Меню/Персонал/Склад), Менеджеры, Кассиры',
    signInNote: 'Менеджеры входят по тому же адресу панели, используя почту и временный пароль, который вы им передаёте.',
    createTitle: 'Создать менеджера',
    emailPlaceholder: 'Эл. почта',
    namePlaceholder: 'Имя и фамилия (необязательно)',
    creating: 'Создание…',
    create: 'Создать менеджера',
    credsTitle: 'Данные менеджера',
    credsNote: 'Скопируйте и отправьте менеджеру. Пароль показывается только один раз.',
    email: 'Почта',
    password: 'Пароль',
    copy: 'Копировать',
    copied: 'Скопировано',
    emptyTitle: 'Менеджеров пока нет',
    count: '{{count}} менеджер(ов)',
    empty: 'Менеджеров пока нет. Создайте выше.',
    colName: 'Имя',
    colEmail: 'Почта',
    colPos: 'Доступ к POS',
    colCreated: 'Создан',
    pinPlaceholder: 'PIN (пусто — автоматически)',
    cashierNo: '№ кассира',
    save: 'Сохранить',
    pinSet: 'PIN задан',
    noPos: 'Нет доступа к POS',
    changePin: 'Сменить PIN',
    setPin: 'Задать PIN',
    newPin: 'Новый PIN: {{pin}} — сообщите менеджеру',
    loading: 'Загрузка…',
  },
  receipt: {
    popupBlocked: 'Всплывающее окно заблокировано. Разрешите всплывающие окна, чтобы напечатать чек.',
  },
  books: {
    title: 'Данные для бухгалтерии',
    subtitle: 'Дневные цифры для ArmSoft. Это не бухгалтерская книга.',
    download: 'Скачать пакет',
    codes: 'Коды ArmSoft',
    codesTitle: 'Коды счетов ArmSoft',
    codesHint:
      'Эти коды пишутся в каждую строку файла, чтобы он совпал с планом счетов в ArmSoft. Оставьте код пустым, если сопоставляете его уже в ArmSoft.',
    cashDesk: 'Касса',
    cardAccount: 'Карта / эквайринг',
    vatIncome: 'Доход с НДС',
    exemptIncome: 'Доход без НДС',
    turnoverIncome: 'Доход по налогу с оборота',
    purchaseAccount: 'Закупки',
    saved: 'Коды сохранены.',
    saveFailed: 'Не удалось сохранить коды.',
    loadFailed: 'Не удалось загрузить данные.',
    empty: 'За этот период ничего нет.',
    paid: 'Оплаченные продажи',
    cash: 'Наличные',
    card: 'Карта',
    missingFiscal: 'Без фискального чека',
    fiscalOk: 'У каждого оплаченного заказа за этот период есть фискальный чек.',
    fiscalGap:
      'У {{count}} оплаченных заказов нет фискального чека ({{amount}}). Разберите расхождение до импорта.',
    day: 'Дата',
    orders: 'Заказы',
    gross: 'Итого',
    tips: 'Чаевые',
    discounts: 'Скидки',
    cogs: 'Себестоимость еды',
    fiscalReceipts: 'Фискальные чеки',
    tax: 'Налог',
    returns: 'Возвраты',
    comps: 'Бесплатно',
    voids: 'Аннулирования',
    purchases: 'Закупки',
    stock: 'Расхождения остатков',
    waste: 'Списания',
    drops: 'Инкассация',
    expenses: 'Расход из кассы',
    b2b: 'ИНН покупателя',
    taxType: 'Тип налога',
    taxVat: 'Облагается НДС',
    taxExempt: 'Без НДС',
    taxTurnover: 'Налог с оборота',
    taxUnknown: 'Без отдела',
    departmentNo: 'Номер отдела',
    departmentName: 'Отдел',
    kind: 'Вид',
    kindSale: 'Продажа',
    kindReturn: 'Возврат',
    kindVoid: 'Аннулирование',
    kindComp: 'Бесплатно',
    orderCash: 'Наличные заказа',
    orderCard: 'Карта заказа',
    onHand: 'Остаток',
    stays: 'Проживания',
    checkIn: 'Заезд',
    checkOut: 'Выезд',
    room: 'Номер',
    guest: 'Гость',
    nights: 'Ночи',
    paymentOption: 'Вариант оплаты',
    paymentStatus: 'Статус оплаты',
    tender: 'Способ',
    source: 'Источник',
    net: 'Нетто',
    supplier: 'Поставщик',
    tin: 'ИНН',
    serial: 'Серия',
    goods: 'Товар',
    qty: 'Количество',
    unit: 'Единица',
    unitPrice: 'Цена',
    lineTotal: 'Сумма строки',
    vat: 'НДС',
    invoiceTotal: 'Сумма накладной',
    ingredient: 'Ингредиент',
    systemQty: 'Количество в системе',
    countedQty: 'Пересчитано',
    delta: 'Разница',
    value: 'Сумма по текущей себестоимости',
    note: 'Примечание',
    expected: 'Ожидалось',
    counted: 'Пересчитано',
    status: 'Статус',
    category: 'Категория',
    description: 'Описание',
    amount: 'Сумма',
    compType: 'Тип бесплатного',
    count: 'Количество',
    order: 'Заказ',
    fiscalNo: 'Номер чека',
    incomeCode: 'Счёт дохода',
    accountCode: 'Код счёта',
    closeReason: 'Причина закрытия',
    sheetSales: 'Продажи',
    sheetTax: 'Налог',
    sheetOrders: 'Заказы',
    sheetOnHand: 'Остаток',
    sheetStays: 'Проживания',
    sheetReturns: 'Возвраты',
    sheetComps: 'Бесплатно',
    sheetVoids: 'Аннулирования',
    sheetPurchases: 'Закупки',
    sheetStock: 'Остатки',
    sheetWaste: 'Списания',
    sheetDrops: 'Инкассация',
    sheetExpenses: 'Расход',
    sheetB2b: 'ИНН',
  },
  staff: {
    title: 'Сотрудники',
    subtitle: 'Люди и их оплата. Новая ставка действует с выбранной даты.',
    add: 'Добавить',
    edit: 'Изменить',
    empty: 'Сотрудников ещё нет. Добавьте человека, чтобы вести часы, зарплату и комплименты.',
    noMatch: 'Никого не найдено.',
    search: 'Найти сотрудника…',
    nameRequired: 'Имя обязательно.',
    colName: 'Имя',
    colPay: 'Оплата',
    colHours: 'Часы',
    colWage: 'Зарплата',
    colTip: 'Чаевые',
    colTotal: 'Итого',
    timesheet: 'Табель',
    timesheetHint: 'Каждая строка — одна смена. Конец позже начала, и смены не пересекаются.',
    start: 'Начало',
    end: 'Конец',
    prevDay: 'Предыдущий день',
    nextDay: 'Следующий день',
    prevMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
    viewDay: 'День',
    viewMonth: 'Месяц',
    monthHint: 'Нажмите ячейку, чтобы указать часы этого человека.',
    openDay: 'Открыть {{name}}, {{date}}',
    duration: '{{hours}} ч {{mins}} мин',
    durationHours: '{{hours}} ч',
    durationMins: '{{mins}} мин',
    fillDrag: 'Потяните, чтобы скопировать ячейку. Пустая ячейка очищает захваченные.',
    off: 'ВЫХОДНОЙ',
    markOff: 'Отметить выходным',
    offHint: 'Этот день выходной. Он не входит в оплачиваемые часы.',
    overlaps: 'Пересечения',
    showOverlaps: 'Кто работает в одно время',
    overlapEmpty: 'В этот день часов нет.',
    overlapNone: 'Никто не работает в одно время.',
    copyToChecked: 'Копировать отмеченным',
    copySlot: 'Копировать это время',
    copyTimes: 'Копировать время',
    copyApply: 'Применить',
    copyNoOne: 'В этот день больше никого нет.',
    addShift: 'Ещё смена',
    sheetSaved: 'Сохранено',
    sheetIncomplete: 'У каждой смены должны быть и начало, и конец.',
    sheetOrder: 'Конец должен быть позже начала.',
    sheetOverlap: 'Смены одного человека не должны пересекаться.',
    payHourly: 'Почасовая',
    payShift: 'За смену',
    payMonthly: 'Месячная',
    perHour: '/ час',
    perShift: '/ смена',
    perMonth: '/ месяц',
    rate: 'Ставка',
    effectiveFrom: 'Действует с',
    effectiveHint: 'Дни до этой даты остаются по прежней ставке.',
    since: 'С {{date}}',
    clockIn: 'Приход',
    clockOut: 'Уход',
    clockedIn: 'С {{time}}',
    notIn: 'Не на смене',
    punches: 'Отметки',
    punchesName: '{{name}}',
    newPunch: 'Новая отметка',
    noPunches: 'В этом диапазоне отметок нет.',
    clockInAt: 'Приход',
    clockOutAt: 'Уход',
    breakMinutes: 'Перерыв (минуты)',
    note: 'Заметка',
    openPunch: 'Ещё на смене',
    punchRequired: 'Нужно время прихода.',
    punchOrder: 'Уход должен быть позже прихода.',
    totalPeople: 'Люди',
    totalHours: 'Часы',
    totalWages: 'Зарплата',
    wageNote:
      'Чаевые с оплаченных заказов делятся по часам. Зарплата считается по ставке того дня.',
    deleteTitle: 'Удалить {{name}}?',
    deleteBody: 'Отметки удалятся. Прошлые комплименты останутся на заказе, уже без этого имени.',
    active: 'Активен',
    onTimesheet: 'В табеле',
    onTimesheetHint: 'Выключите, если человек только получает комплименты. Он остаётся на кассе и не входит в часы, зарплату и чаевые.',
    compOnly: 'Только комплимент',
    rateHistory: 'История ставок',
    rateInForce: 'Действует',
    rateDeleteTitle: 'Удалить ставку от {{date}}?',
    rateDeleteBody: 'С этой даты снова действует предыдущая ставка.',
    sort: 'Порядок',
  },
} as const;
